<template>
  <div class="accountInfo">
    <head-panel title="账号管理" subtitle="ACCOUNT MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">{{currentTitle}}</h3>
      <el-tabs
        v-model="mediaTab"
        @tab-click="handleClick({ platform: 'advertiser'})"
        class="is-simple"
        v-if="!isAgency"
      >
        <el-tab-pane label="多牛账户信息" name="1"></el-tab-pane>
        <el-tab-pane label="小米账户信息" :disabled="auditStatus !== 1" name="2"></el-tab-pane>
        <el-tab-pane label="掌阅账户信息" :disabled="auditStatus !== 1" name="3"></el-tab-pane>
      </el-tabs>
      <el-form
        :model="commonForm"
        ref="commonForm"
        class="ruleForm"
        label-width="12%;"
        v-if="mediaTab !== '1' && !isAgency"
      >
        <h4 class="form-title">账户信息</h4>
        <el-form-item
          label="行业类型"
          prop="industrySecondType"
          v-if="!isAgency"
          :rules="[{ required: true, message: '请选择行业类型', trigger: 'blur' }]"
        >
          <ny-select
            :data="accountinfo.commonForm.industryMenu"
            v-model="commonForm.industryType"
            :keyValue="['id', 'name']"
            @change="({ value }) => changeIndustry({value: value, form:'commonForm', isEdit: commonForm.isEdit, platform: 'advertiser' })"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm mr20"
            :disabled="commonForm.isEdit"
          ></ny-select>
          <ny-select
            :data="accountinfo.commonForm.industrySecondMenu"
            v-model="commonForm.industrySecondType"
            @change="({ value }) => changeIndustrySecondType({value: value, form:'commonForm', isEdit: commonForm.isEdit, platform: 'advertiser' })"
            :keyValue="['id', 'name']"
            type="industryType"
            placeholder="请选择"
            :disabled="commonForm.isEdit"
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <Industry
          :industryData.sync="industryData"
          :post="post"
          ref="industry"
          :loading="commonForm.loading"
          :deleteArray="deleteArray"
          :disabled="industryDisabled"
        ></Industry>
        <el-form-item class="btnGroups">
          <el-button
            class="commit"
            type="primary"
            @click="submitMediaForm('commonForm', 'advertiser')"
            :disabled="commonForm.committing"
          >{{commonForm.committing ? '提交中···' : '提交'}}</el-button>
        </el-form-item>
      </el-form>
      <el-form
        :model="form"
        ref="form"
        class="ruleForm"
        :rules="rules"
        label-width="12%"
        v-if="mediaTab === '1'"
      >
        <h4 class="form-title">账户信息</h4>
        <el-form-item label="账户名称" prop="name">
          <el-input class="input_sm" placeholder="请输入账户名称" v-model="form.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="公司名称(广告主名称)" prop="company" disabled>
          <el-input class="input_lg" placeholder="请输入公司名称(广告主名称)" v-model="form.company" disabled></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input class="input_sm" placeholder="请输入邮箱" v-model="form.email" disabled></el-input>
        </el-form-item>
        <el-form-item label="网站URL" prop="url">
          <el-input v-model="form.url" class="input_lg" placeholder="请输入网站URL" disabled></el-input>
        </el-form-item>
        <el-form-item label="行业类型" prop="industryType" v-if="!isAgency">
          <ny-select
            :data="accountinfo.form.industryMenu"
            v-model="form.industryType"
            :keyValue="['id', 'name']"
            @change="({ value }) => changeIndustry({value: value, form:'form', isEdit: true })"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm mr20"
            disabled
          ></ny-select>
          <ny-select
            :data="accountinfo.form.industrySecondMenu"
            v-model="form.industrySecondType"
            :keyValue="['id', 'name']"
            type="industryType"
            placeholder="请选择"
            disabled
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <Industry
          :industryData.sync="industryData"
          :post="post"
          ref="industry"
          :deleteArray="deleteArray"
          :disabled="industryDisabled"
        ></Industry>
        <el-form-item label="注册地址">
          <city-select
            class="address-select"
            :arrCity="accountInfo.cityArr"
            @changeSelect="changeSelectCity"
            part="registerCity"
            :defaultCity="form.registerCity"
            :disabled="isSuccess"
          ></city-select>
          <el-input
            class="input_lg ml16"
            placeholder="请输入地址"
            v-model="form.address"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <h4 class="form-title">联系人信息</h4>
        <el-form-item label="联系人姓名" prop="contacter">
          <el-input
            class="input_sm"
            placeholder="请输入联系人姓名"
            v-model="form.contacter"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="phone">
          <el-input
            class="input_sm"
            placeholder="请输入手机号"
            v-model="form.phone"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人地址" prop="linkAddress">
          <city-select
            class="address-select"
            part="linkCity"
            :arrCity="accountInfo.cityArr"
            @changeSelect="changeSelectCity"
            :defaultCity="form.linkCity"
            :disabled="isSuccess"
          ></city-select>
          <el-input
            class="input_lg ml16"
            placeholder="请输入地址"
            v-model="form.linkAddress"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button
            size="large"
            type="primary"
            @click="submitForm('form')"
            v-if="!isSuccess"
            :disabled="committing"
          >{{committing ? '提交中···' : '提交'}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="auditStatus"
      v-if="titleShow.donews && this.mediaTab === '1'"
    >{{auditStatus === 1 ? status1 : (auditStatus === 0 ? status0.donews : (status2.donews + '('+ auditReason +')'))}}</div>
    <div
      class="auditStatus"
      v-if="titleShow.verify && this.mediaTab !== '1'"
    >{{verify.auditStatus === 1 ? status1 : (verify.auditStatus === 0 ? status0.verify.replace(/小米/g, this.commonForm.auditMsg[this.mediaTab]) : (status2.verify.replace(/小米/g, this.commonForm.auditMsg[this.mediaTab]) + '('+ verify.auditReason +')'))}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { headPanel, NySelect, citySelect } from '@/global/components';
import Industry from '@/global/views/subAccount/industry.vue'
import IndustryMixns from '@/global/views/subAccount/industry.js'
import { post, get, patch, remove } from '@/advertiser/http';
export default {
  mixins: [IndustryMixns],
  data () {
    var industryType = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择行业类型'));
      } else {
        callback();
      }
    };
    // var publicBank = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请选择对公银行'));
    //   } else {
    //     callback();
    //   }
    // };
    // var subBranch = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入对公开户支行'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      post: post,
      get: get,
      patch: patch,
      remove: remove,
      currentTitle: '账户信息',
      status0: {
        donews: '您尚未通过身份验证，无法正常使用，请在账户管理中完善信息',
        verify: '您的小米账户尚未通过身份验证，无法正常使用， 请在小米账户信息中完善 '
      }, // 待审核或者未提交
      status1: '账户信息审核成功', // 通过
      status2: {
        donews: '账户信息审核未通过：请重新提交资质',
        verify: '您的小米账户信息审核未通过：请重新提交资质'
      }, // 未通过
      auditStatus: 0,
      auditReason: '', // 拒绝原因
      verify: {
        auditStatus: 0,
        auditReason: ''
      },
      committing: false, // 提交按钮的提交状态
      isSuccess: false,
      uploadPost: 'test',
      isNew: false,
      titleShow: {
        donews: false,
        verify: false
      },
      isAgency: false,
      form: {
        name: '',
        pass: '',
        checkPass: '',
        email: '',
        company: '',
        industryType: '',
        url: '',
        address: '',
        registerCity: {},
        contacter: '',
        phone: '',
        linkAddress: '',
        linkCity: {},
        loading: false
      },
      rules: {
        name: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }
        ],
        company: [{ required: true, message: '请输入公司名称(广告主名称)', trigger: 'blur' }],
        industryType: [{ required: true, validator: industryType, trigger: 'change' }],
        url: [{ required: false, message: '请输入网站url', trigger: 'blur' },
          { required: false, type: 'url', message: '请输入正确网站url', trigger: 'blur,change' }],
        contacter: [{ required: false, max: 50, message: '输入内容不得超过50个字符', trigger: 'blur' }],
        phone: [{ required: false, pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }],
        linkAddress: [{ required: false, max: 50, message: '输入内容不得超过50个字符', trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...mapGetters({
      accountInfo: 'account/account',
      userid: 'login/userid',
      user: 'login/user'
    })
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      await this.$store.dispatch('account/getCityAll')
      await this.getAccountInfo()
    },
    getAccountInfo () {
      get('/ad-user/account/' + this.userid).then(res => {
        if (res.code === 1) {
          let data = res.data
          if (!data && typeof (data) !== 'undefined' && data !== 0) {
            this.isNew = true
            this.auditStatus = 0
            this.titleShow.donews = true

            /**
             * 禁用原因, 因审核平台原因,账户信息状态判定取消
             */
            // this.isSuccess = this.industryDisabled = this.auditStatus !== 2
            return false
          }
          this.form.registerCity = {
            prov: data.reg_pro + '',
            city: data.reg_city + '',
            district: data.reg_area + ''
          }
          /**
           * status:
          */
          this.auditStatus = parseInt(data.audit_status)
          // this.isSuccess = this.industryDisabled = this.auditStatus !== 2
          this.auditReason = data.audit_reason.msg ? data.audit_reason.msg : ''
          this.titleShow.donews = true
          if (this.auditStatus === 1) {
            if (!data.first_pass) {
              this.titleShow.donews = false
            }
            setTimeout(() => {
              this.titleShow.donews = false
            }, 10000)
          }
          this.form.address = data.reg_address
          // 联系人
          this.form.contacter = data.username
          this.form.phone = data.tel
          this.form.linkCity = {
            prov: data.pro + '',
            city: data.city + '',
            district: data.area + ''
          }
          this.form.linkAddress = data.address
        }
      })
      get('/ad-user/user/' + this.userid).then(async res => {
        if (res.code === 1) {
          let data = res.data
          /**
           *1:KA广告主 2:广告主 4:二级管理员  6:管理员 7：财务/商务 8:优化师 9：观察者 10：普通管理员 11：一级代理商 12：二级代理商 13：三级代理商
          */
          let AgencyIdTag = ['4', '11', '12', '13']
          this.isAgency = AgencyIdTag.indexOf(data.id_tag.toString()) > -1
          this.getIndustryDetails(this.isAgency, this.user.id)
          this.form.name = data.username
          this.form.company = data.corporate_name
          this.form.email = data.email
          this.form.industrySecondType = data.industry + ''
          this.form.industryType = data.parent_industry + ''
          await this.getIndustryMenu({ type: this.form.industryType })
          this.commonForm.xiaomi.industryType = data.mi_parent_industry + '' !== '0' ? data.mi_parent_industry + '' : ''
          this.commonForm.xiaomi.industrySecondType = data.mi_industry + '' !== '0' ? data.mi_industry + '' : ''
          this.commonForm.zhangyue.industryType = data.ireader_parent_industry + '' !== '0' ? data.ireader_parent_industry + '' : ''
          this.commonForm.zhangyue.industrySecondType = data.ireader_industry + '' !== '0' ? data.ireader_industry + '' : ''
          this.form.url = data.web_url
        }
      })
    },
    changeSelect (value) {
    },
    changeSelectCity ({ prov, city, district, part }) {
      this.form[part] = { prov, city, district, part }
    },
    getParams () {
      let params = {}
      params.user_id = this.userid
      params.corporate_name = this.form.company // 通用信息
      params.industry = this.isAgency ? '' : this.form.industrySecondType
      params.web_url = this.form.url
      params.reg_pro = this.form.registerCity.prov
      params.reg_city = this.form.registerCity.city
      params.reg_area = this.form.registerCity.district
      params.reg_address = this.form.address
      params.username = this.form.contacter // 联系人信息
      params.tel = this.form.phone
      params.pro = this.form.linkCity.prov
      params.city = this.form.linkCity.city
      params.area = this.form.linkCity.district
      params.address = this.form.linkAddress
      return params
    },
    submitForm (numberValidateForm) {
      let self = this
      this.$refs[numberValidateForm].validate((valid) => {
        this.$refs.industry.$refs.industryForm.validate((validIn) => {
          let params = self.getParams()
          let uid = self.isNew ? '' : self.userid
          if (valid && validIn) {
            this.committing = true;
            let promiseArr = [
              post('/ad-user/account/' + uid, params),
              this.submitIndustry({ userid: this.user.id, form: numberValidateForm })
            ]
            if (this.deleteArray.length > 0) {
              promiseArr.push(this.submitDelete())
            }
            Promise.all(promiseArr).then(data => {
              let suc = data.every(res => {
                if (res.code !== 1) {
                  this.committing = false;
                  this.$message.error(res.msg)
                }
                return res.code === 1
              })
              if (suc) {
                this.committing = false;
                self.getAccountInfo()
                self.$message('更改成功')
              }
            }).catch(() => {
              this.committing = false
            })
          }
        })
      });
    }
  },
  components: {
    headPanel,
    NySelect,
    citySelect,
    Industry
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.accountInfo {
  .el-tabs.is-simple {
    .el-tabs__active-bar {
      width: 129px !important;
    }
  }
  .ruleForm {
    .input_sm {
      width: 210px;
    }
    .input_lg {
      width: 350px;
    }
    .ml16 {
      margin-left: 16px;
    }
    .mr20 {
      margin-right: 20px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .upload_select {
      position: absolute;
      left: 16px;
    }
    .upload-demo {
      width: 310px;
      .el-upload__tip {
        position: absolute;
        top: -7px;
        left: 90px;
      }
    }
    .col-upload {
      margin-left: 16px;
      .el-upload__tip {
        position: absolute;
        top: 23px;
        left: 90px;
      }
      .el-upload-list {
        margin-left: 0;
      }
    }
    .form-title {
      margin-left: 20px;
      font-size: 16px;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .btnGroups {
      text-align: left;
      margin-left: 16px;
    }
    .address-select {
      display: inline-block;
      margin-bottom: 20px;
    }
  }
  .auditStatus {
    width: 100%;
    line-height: 30px;
    background: #fdff92;
    position: absolute;
    top: 45px;
    box-sizing: border-box;
    padding-left: 50px;
    left: 200px;
    transition: all 0.3s;
  }
  .imgShow {
    text-align: center;
    img {
      max-width: 100%;
      height: auto;
    }
    .el-dialog--small {
      width: 50%;
    }
  }
}
.is-collapse {
  .accountInfo {
    .auditStatus {
      left: 64px;
    }
  }
}
</style>
